<template>
  <div class="animated fadeIn">
    <b-tabs>
      <b-tab title="Lead" active>
        <leads-detail
          v-if="leadForm && !loading"
          :flag="'1'"
          :lead-form="leadForm"
          :loading="loading"
          :my-location="myLocation"
          :questioner="questioner[leadForm.lead_code]"
        ></leads-detail>
        <loading v-else></loading>

      </b-tab>
      
      <template v-for="(v, index) in leadHistory" >
        <b-tab :key="uniqueId(index+'ques_main')" :title="v.lead_code_history">
           <leads-detail
            v-if="v"
            :flag="'2'"
            :lead-form="v"
            :loading="loading"
            :id="v.lead_code_history"
            :my-location="{lat: parseFloat(v.lat), lng: parseFloat(v.lng)}"
            :questioner="questionerHistory[v.lead_code_history]"
          ></leads-detail>
        </b-tab>
      </template>
    </b-tabs>
  </div>
</template>


<script>
import axios from "axios";
import globalTable from "../../templates/Table.vue";
import interfaces from "@/templates/_interfaces.js";
import custom_validation from "@/templates/_customValidation.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import * as moment from "moment";
import "moment/locale/id";
import { ModelSelect, MultiSelect } from "vue-search-select";
import leadsDetail from "@/templates/LeadsDetail";
import tabQuesioner from "./tabs/Questionnaire";
import _ from "lodash";
import loading from "@/templates/Loading.vue";

export default {
  name: "customer",
  components: {
    globalTable,
    ModelSelect,
    MultiSelect,
    tabQuesioner,
    leadsDetail,
    // documentCustomer,
    // assetReturn,
    // assetPlacementAlter,
    loading,
  },
  props: {
    tableDetail: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: true,
      myLocation: null,
      urlAssets: "https://storage.googleapis.com/mbsstorage/",
      listProvince: [],
      listRegencies: [],
      listDistrict: [],
      listVillage: [],
      questioner: [],
      questionerHistory: [],
      leadForm: interfaces.leads,
      leadHistory: null,
      selectedAttachmentFile: null,
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function (lead_id) {
      this.loading = true;
      this.getCustomerDetail(lead_id);
      this.isEdit = false;
    },
     uniqueId: function (param = "") {
      return _.uniqueId(param);
    },
    getCustomerDetail(lead_id) {
      this.axios
        .get("web/leads/detail/" + lead_id + "/")
        .then((response) => {
          this.leadForm = response.data.data;
          this.myLocation = {
            lat: this.leadForm.lat,
            lng: this.leadForm.lng,
          };
          this.questioner = response.data.questioner;
          // console.log(this.questioner);
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
          this.getCustomerHistory(this.leadForm.lead_code);
        });
    },
     getCustomerHistory(lead_code) {
      this.axios
        .get("web/leads/history-detail/" + lead_code + "/")
        .then((response) => {
          this.leadHistory = response.data.data;
          this.questionerHistory = response.data.questioner;
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    expired: function (error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message,
        });
      }
    },
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  },
};
</script>